import gsap from "gsap";

const toggleMenu = document.querySelector(".header__button");

const tl = gsap.timeline({ reversed: true });

tl.from("header nav", {
  duration: 0.4,
  ease: "power3.inOut",
  top: "-500%",
}).from("header nav li", {
  duration: 0.3,
  opacity: 0,
  y: 20,
  ease: "power3.inOut",
  stagger: 0.05,
});

function animateIt() {
  tl.reversed() ? tl.play() : tl.reverse();
  toggleMenu.classList.toggle('active');
}

var mediaQueryList = window.matchMedia('(min-width: 1024px)');

// Set things up on load
if(mediaQueryList.matches) {
  tl.pause(1)
} else {
  toggleMenu.addEventListener('click', animateIt);
  tl.pause(0)
}

// This handles resizes, when passing that breakpoint at 1024px
function toggleStateOnResize(e) {
  
  console.log('Breakpoint of 1024px passed.')
  
  if (e.matches) {
    // WIDE SCREEN
    toggleMenu.removeEventListener('click', animateIt);
    tl.pause(1)

  } else {
    // NARROW SCREEN
    toggleMenu.addEventListener('click', animateIt);
    tl.pause(0).reversed(true)
  }
}

mediaQueryList.addEventListener("change", toggleStateOnResize);